/** Function to globally set a given theme. Ensures that
 * no other themes are set (only the given one).
 * Quick hack for a demo, of course ;-)
 */
import slug from "slug";

export default company => {
  // Theme name
  const theme = slug(company.replace(/https?:\/\/|www\./g, "").replace(/\./g, "-"));
  console.log(theme);
  // If not 'travelstart' it's 'bluesky' by default
  const dTheme = theme === "travelstart-co-za" || theme === "rogers-mu" || theme === "ross-consulting" || theme === "ba-com" || theme === "trans-end-com" ? theme : "default";

  document.body.setAttribute("data-theme", dTheme);
};



// WEBPACK FOOTER //
// ./src/ndc/theme/setThemeForCompany.js